import { useTranslations } from '@vocab/react';
import { Loader, Stack, Text } from 'braid-design-system';
import React from 'react';

import { FormDrawer } from 'src/components/FormDrawer/FormDrawer';
import { CLASSIFICATION } from 'src/components/Router';
import { NEXT_ROLE_CLASSIFICATION_FORM } from 'src/reducers/forms';

import { NextRoleDetail } from '../../ReadNextRole/NextRoleDetail/NextRoleDetail';
import { NextRoleSection } from '../../types';
import { EditClassification } from '../EditClassification/EditClassification';
import {
  useGetClassificationOptions,
  usePreferredClassification,
} from '../data';

import translations from './.vocab';

export const ReadClassification = () => {
  const { t } = useTranslations(translations);
  const { preferredClassification, error } = usePreferredClassification();
  const hasPreferredClassification = preferredClassification !== null;
  const { getClassificationText } = useGetClassificationOptions();

  const classification = hasPreferredClassification
    ? getClassificationText(
        preferredClassification.id,
        preferredClassification.subClassification.id,
      )
    : null;

  return (
    <>
      <NextRoleDetail
        title={t('Classification of interest')}
        section={NextRoleSection.classification}
      >
        {error ? (
          <Loader data={{ automation: 'preferred-classification-loading' }} />
        ) : (
          hasPreferredClassification && (
            <Stack space="small">
              <Text tone="secondary" size="small" weight="strong">
                {classification?.classificationText}
              </Text>
              <Text>{classification?.subClassificationText}</Text>
            </Stack>
          )
        )}
      </NextRoleDetail>
      <FormDrawer
        title={t('Classification of interest')}
        component={EditClassification}
        card={CLASSIFICATION}
        formName={NEXT_ROLE_CLASSIFICATION_FORM}
      />
    </>
  );
};
